import { endOfMonth, format, startOfMonth, subMonths, subYears } from 'date-fns'
import { ATSAnalyticsFilterPeriod, ATSChartPeriod } from 'redux/ATS/analytics/jobDetail/types'
import { GetJobOverViewData } from 'redux/ATS/analytics/jobOverview/types'
import i18n from 'translations/i18n'
import { CardInfo } from '../components/ChartBreakdown/ChartBreakdown'

export type ATSFiltersValues = {
  filter: ATSAnalyticsFilterPeriod
  filters_details: {
    all_filters?: 'all_filters'
    job_status?: 'open' | 'closed'
    details: {
      filterLabel: string
      label: string | number
      value: string | number
    }
  }
  from: string
  period_type: ATSChartPeriod
  to: string
  organization_id?: number
}
export const getJobOverviewCards = (jobOverviewData: GetJobOverViewData): CardInfo[][] => {
  return [
    [
      {
        title: i18n.t('open'),
        value: jobOverviewData?.open_job?.toString(),
      },
      {
        title: i18n.t('hired_candidates'),
        value: jobOverviewData.hired_candidates?.toString(),
        statusColor: 'var(--ds-base-color-informational-success-fg-dark)',
      },
      {
        title: i18n.t('closed_with_no_hires'),
        value: jobOverviewData.close_job_with_no_hired_candidates?.toString(),
        statusColor: 'var(--ds-base-color-actionable-warning-bg-light)',
      },
    ],
    [
      {
        title: i18n.t('closed'),
        value: jobOverviewData.close_job?.toString(),
        statusColor: 'var(--ds-core-color-error-700)',
      },
      {
        title: i18n.t('open_with_no_hires'),
        value: jobOverviewData.open_job_with_no_hired_candidates?.toString(),
        statusColor: 'var(--ds-core-color-info-700)',
      },
    ],
  ]
}

const DATE_FILTERS = {
  end: endOfMonth(subMonths(new Date(), 1)),
  start: subYears(startOfMonth(subMonths(new Date(), 1)), 1),
}

export const initialAnalyticsValue: ATSFiltersValues = {
  period_type: 'monthly',
  to: format(DATE_FILTERS.end, 'yyyy-MM-dd'),
  from: format(DATE_FILTERS.start, 'yyyy-MM-dd'),
  filter: {},
  filters_details: {
    all_filters: 'all_filters',
    details: {
      filterLabel: 'All Filters',
      label: i18n.t('ats_all_filters') as string,
      value: 'all_filters',
    },
  },
}
